<template>
    <div :class="['video-time-item', {'not-logged': disabled}, {'in-progress': isItemInProgress}]" @click="setTimeInVideo">
        <div class="video-time-item__section" v-if="isLabel"> {{ title }}</div>
        <div v-else role="button" :class="['video-time-item__content', {'in-progress': isItemInProgress}]">
            <span class="video-time-item__icon icon-film1"></span>
            <div class="video-time-item__timecode-container">
                <span class="video-time-item__title"> {{ title }} </span>
                <span class="video-time-item__time"> {{ time }} </span>
            </div>
            <span class="icon-checked" v-if="isSectionWatched && !disabled || videoTimeCompleted"></span>
                <span v-if="isItemInProgress">
                    <Progress
                    class="progress-circle"
                    :radius="10"
                    strokeColor="#e47700"
                    v-bind:value="progressPercent"
                    :transitionDuration="4000">
                    <div class="content"></div>
                    </Progress>
                </span>
        </div>
    </div>
</template>

<script>
    import truncate from 'components/shared/mixins/truncate'
    import Progress from 'easy-circular-progress'
    import rangeHandler from 'helpers/rangeHandler'
    import { mapGetters } from 'vuex'

    export default {
        name: 'VideoTimeLinksItem',
        props: {
            time: String || Number,
            title: String,
            sequence: {
                type: Array,
                default: () => []
            },
            timeItemIndex: Number,
            videoTimeCompleted: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            allCurrentlyWatchedSequences: {
                type: Array,
                default: () => []
            },
            videoDuration: Number,
            isLast: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Progress,
        },
        mixins: [ truncate ],
        computed: {
            isLabel () {
                return this.time === ''
            },
            durationOfSection () {
                if (this.isLabel) {
                    return null
                }

                return rangeHandler.sumRanges([this.sequence])
            },
            isSectionWatched () {
                if (this.isLabel) {
                    return false
                }
                return this.progressPercent >= 95
            },
            isItemInProgress () {
                return !this.isLabel && this.progressPercent > 0 && !this.disabled && this.progressPercent < 95
            },
            currentWatched () {
                return rangeHandler.getOverlappingLength(this.allCurrentlyWatchedSequences, this.sequence)
            },
            progressPercent () {
                return Math.max(Math.round(this.currentWatched / this.durationOfSection * 100))
            },
            ...mapGetters({
                videoPosition: 'VideoPlayer/position'
            })
        },
        methods: {
            setTimeInVideo () {
                if (!this.disabled) {
                    this.$store.dispatch('VideoPlayer/moveVideo', this.convertTimeToSeconds(this.time))
                }
            },
            convertTimeToSeconds (time) {
                let splittedTime = time.split(':')
                let hoursInseconds = (parseInt(splittedTime[0]) * 60 * 60)
                let minutesInseconds = (parseInt(splittedTime[1]) * 60)
                let seconds = parseInt(splittedTime[2])
                return hoursInseconds + minutesInseconds + seconds
            },
        },
        watch: {
            isSectionWatched () {
                if (this.isSectionWatched === true) {
                    this.$store.dispatch('VideoPlayer/persistPlays')
                }
            },
            immediate: true
        }
    }
</script>

<style lang="scss" scoped>
    .video-time-item {
        display: flex;
        flex-direction: column;
        font-size: 1.3rem;
        position: relative;
        color: $white;
        font-family: Quicksand-Regular, sans-serif;

        &.not-logged {
            color: $white;
            .video-time-item {
                &__section {
                    @include white(color, 0.3);
                }

                &__content {
                    &:hover {
                        cursor: default;
                        background: $heavy_metal;
                    }
                }

                &__time {
                    @include orange(color, 0.3);
                }

                &__title {
                    @include white(color, 0.3);
                }

                &__icon {
                    @include white(color, 0.3);
                    cursor: default;
                }
            }
        }

        &__section {
            font-family: Quicksand-Bold, sans-serif;
            color: $white;
            padding: 15px 15px;
        }

        &__content {
            display: flex;
            padding: 15px 15px;
            background: $heavy_metal;
            position: relative;
            flex-direction: row;
            align-items: center;

            &:hover {
                cursor: pointer;
                @include white(background, 0.1);
            }
            &.in-progress {
                @include white(background, 0.1);
            }
        }

        &__timecode-container {
            flex-direction: column;
            display: flex;
        }

        &__time {
            color: $orange;
            margin: 0 10px 0 0;
            width: 100%;
            font-size: 1.2rem;
        }

        &__title {
            font-size: 1.3rem;
            max-width: 210px;
            font-family: Quicksand-Regular, sans-serif;
            [class*="desktop_xxxl"] & {
                max-width: 280px;
            }
        }

        &__icon {
            margin: 0 16px 0 0;
            font-size: 1.8rem;
        }

        .icon-checked {
            color: $ice_cold;
            position: absolute;
            right: 15px;
            top: 20px;
            font-size: 2rem;
        }
        .progress-circle {
            position: absolute;
            right: 10px;
            top: 13px;
        }
    }
</style>
